

























































import { Component, Vue, Emit, Mixins, Prop } from 'vue-property-decorator';
import { AA } from '@/lib/mixin'

@Component
export default class Nav extends Mixins(Vue, AA) {
    @Prop() activeNav!: number
    @Emit('changeNav')
    changeNav(idx: number) {
        if (this.activeNav === idx) {
            return
        }
        this.tracking({isAction: true, pageName: `Training_Home_${this.activeNav}`, actionName: `Training_Nav_${idx}`})
        return idx
    }
}
